import { render, staticRenderFns } from "./ProjectRemoveModal.vue?vue&type=template&id=ae157524"
import script from "./ProjectRemoveModal.vue?vue&type=script&lang=js"
export * from "./ProjectRemoveModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports